var exports = {
  "kL": "x8b4e8595--49a793--container",
  "pF": "x8b4e8595--49a793--station",
  "vd": "x8b4e8595--49a793--travel-time",
  "Kk": "x8b4e8595--49a793--icon",
  "UU": "x8b4e8595--49a793--name",
  "hl": "x8b4e8595--49a793--address",
};

module.exports = exports;
